import Vue from 'vue'
import VueFlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

Vue.use(VueFlatPickr)
